import React from 'react'
import { Component } from 'react'
import { Navigate } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService'
import apiRequests from '../api-helpers/ApiRequests'

export default class AuthorizeComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false,
        };

        
        this.authenticationChanged = this.authenticationChanged.bind(this);
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    render() {

        const { ready, authenticated, isPasswordChanged } = this.state;
        var link = document.createElement("a");
        link.href = this.props.path;
        const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
        const redirectUrl = `${ApplicationPaths.ApiAuthorizationPrefix}${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`
        const redirectUrlPasswordChange = "/changepassword";

        if (ready) {
            const { component: Component, ...rest } = this.props;

            if (authenticated) {

                //if (!this.props.isPasswordChanged && !this.props.isChangePasswordComponent)
                //    return (<Navigate to={redirectUrlPasswordChange} />);

                if (this.props.layoutReady)
                    return (<Component {...rest} />);
                else
                    return <div></div>;
            }
            else {
                return (<Navigate to={redirectUrl} />);
            }
        } else {

            return <div></div>;
         
        }
    }

    async populateAuthenticationState() {

        const authenticated = await authService.isAuthenticated();
        this.setState({ ready: true, authenticated});
    }

    async authenticationChanged() {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }
}

